import { create } from 'zustand';
import { clientsApi } from '@/api';

const useClientStore = create((set, _get) => ({
  clients: [],
  total: 0,
  loading: false,
  error: null,

  fetchClients: async (params = {}) => {
    set({ loading: true, error: null });
    try {
      const data = await clientsApi.list(params);
      set({ clients: data.items, total: data.total, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  createClient: async (data) => {
    set({ loading: true, error: null });
    try {
      const newClient = await clientsApi.create(data);
      set((state) => ({
        clients: [...state.clients, newClient],
        total: state.total + 1,
        loading: false,
      }));
      return newClient;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  updateClient: async (id, data) => {
    set({ loading: true, error: null });
    try {
      const updated = await clientsApi.update(id, data);
      set((state) => ({
        clients: state.clients.map((c) => (c.id === id ? updated : c)),
        loading: false,
      }));
      return updated;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  deleteClient: async (id) => {
    set({ loading: true, error: null });
    try {
      await clientsApi.delete(id);
      set((state) => ({
        clients: state.clients.filter((c) => c.id !== id),
        total: state.total - 1,
        loading: false,
      }));
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },
}));

export default useClientStore;
